/* ============================================================================
 * Project        : Deloitte Digital Compliance
 * File           : adminSetttingAPI.jsx
 * Version        : 1.0.0
 * Author         : Team Neubinary
 * Created On     : 2026-06-24
 *
 * Description    : Digital Compliance for Automation and Governance
 *
 * Change History :
 * ----------------------------------------------------------------------------
 * Date         | Version | Author           | Description
 * ----------------------------------------------------------------------------
 * 2026-06-24   | 1.0.0   | Team Neubinary   | Initial creation
 * <YYYY-MM-DD> | x.x.x   | <Name/Team>      | <Change description>
 * ============================================================================
 *
 * Copyright (c) 2026 AU79 Consulting Services Pvt. Ltd.
 * All Rights Reserved.
 *
 * This source code and its contents are confidential and proprietary to
 * AU79 Consulting Services Pvt. Ltd. Unauthorized copying, reproduction,
 * modification, distribution, or disclosure of this material, in whole or
 * in part, is strictly prohibited without prior written permission from
 * AU79 Consulting Services Pvt. Ltd.
 * ============================================================================
 */
/**
 * @author Abdul Rahim M-abdul@au79consulting.com
 * @date 13-07-2024
 * @description  AdminSettings API documentation Apis
 */
import actionType from "../actionTypes";
const adminSettingsAPI = {
  //AdminSettings Action
  get_admin_settings: {
    api_name: "/SCM/settings/get",
    https_method: "GET",
    action_type: actionType.GET_ADMIN_SETTINGS,
    description: "Get the Admin Settings",
  },

  //Zone Details
  add_zone_details: {
    api_name: "/SCM/settings/zone/details",
    https_method: "PUT",
    action_type: actionType.ADD_ZONES,
    description: " Add Zone Settings",
  },
  delete_zone_details: {
    api_name: "/SCM/settings/zone/details/delete",
    https_method: "PUT",
    action_type: actionType.DELETE_ZONES,
    description: "DELETE  Zone Settings",
  },

  //Architecture Types
  add_architecture_types: {
    api_name: "/SCM/settings/architecture/types",
    https_method: "PUT",
    action_type: actionType.ADD_ARCHITECTURE_TYPES,
    description: "ADD Architecture Types",
  },
  delete_architecture_types: {
    api_name: "/SCM/settings/architecture/types/delete",
    https_method: "PUT",
    action_type: actionType.DELETE_ARCHITECTURE_TYPES,
    description: "DELETE Architecture Types",
  },

  //Powertrainclass

  add_powertrain_class: {
    api_name: "/SCM/settings/pc",
    https_method: "POST",
    action_type: actionType.ADD_POWETRAIN_CLASS,
    description: "ADD PowerTrain Class",
  },
  get_powertrain_class: {
    api_name: "/SCM/settings/pc",
    https_method: "GET",
    action_type: actionType.GET_POWETRAIN_CLASS,
    description: "GET PowerTrain Class",
  },
  update_powertrain_class: {
    api_name: "/SCM/settings/pc",
    https_method: "PUT",
    action_type: actionType.UPDATE_POWETRAIN_CLASS,
    description: "UPDATE PowerTrain Class",
  },
  delete_powertrain_class: {
    api_name: "/SCM/settings/pc/delete",
    https_method: "PUT",
    action_type: actionType.DELETE_POWETRAIN_CLASS,
    description: "DELETE PowerTrain Class",
  },

  //Vehicle Function
  add_vehicle_function: {
    api_name: "/SCM/settings/vf",
    https_method: "POST",
    action_type: actionType.ADD_VEHICLE_FUNCTION,
    description: "ADD Vehicle Function",
  },
  get_vehicle_function: {
    api_name: "/SCM/settings/vf",
    https_method: "GET",
    action_type: actionType.GET_VEHICLE_FUNCTION,
    description: "GET Vehicle Function",
  },
  update_vehicle_function: {
    api_name: "/SCM/settings/vf",
    https_method: "PUT",
    action_type: actionType.UPDATE_VEHICLE_FUNCTION,
    description: "UPDATE Vehicle Function",
  },
  delete_vehicle_function: {
    api_name: "/SCM/settings/vf/delete",
    https_method: "PUT",
    action_type: actionType.DELETE_VEHICLE_FUNCTION,
    description: "DELETE Vehicle Function",
  },

  //Vehicle Class

  add_vehicle_class: {
    api_name: "/SCM/settings/vc",
    https_method: "POST",
    action_type: actionType.ADD_VEHICLE_CLASS,
    description: "ADD Vehicle Class",
  },
  get_vehicle_class: {
    api_name: "/SCM/settings/vc",
    https_method: "GET",
    action_type: actionType.GET_VEHICLE_CLASS,
    description: "GET Vehicle Class",
  },
  update_vehicle_class: {
    api_name: "/SCM/settings/vc",
    https_method: "PUT",
    action_type: actionType.UPDATE_VEHICLE_CLASS,
    description: "UPDATE Vehicle Class",
  },
  delete_vehicle_class: {
    api_name: "/SCM/settings/vc/delete",
    https_method: "PUT",
    action_type: actionType.DELETE_VEHICLE_CLASS,
    description: "DELETE Vehicle Class",
  },

  //mft_details

  add_mft_details: {
    api_name: "/SCM/settings/add/vehicle-manufacturer",
    https_method: "PUT",
    action_type: actionType.ADD_MFT_DETAILS,
    description: "Add Mft Details",
  },
  delete_mft_details: {
    api_name: "/SCM/settings/remove/vehicle-manufacturer",
    https_method: "PUT",
    action_type: actionType.DELETE_MFT_DETAILS,
    description: "Remove Mft Details",
  },
  get_mft_details: {
    api_name: "/SCM/settings/search/vehicle-manufacturers",
    https_method: "GET",
    action_type: actionType.GET_MFT_DETAILS,
    description: "Get Mft Details",
  },

  //supplier_details

  add_supplier_details: {
    api_name: "/SCM/settings/add/suppliers",
    https_method: "PUT",
    action_type: actionType.ADD_SUPPLIER_DETAILS,
    description: "Add Supplier Details",
  },
  delete_supplier_details: {
    api_name: "/SCM/settings/remove/suppliers",
    https_method: "PUT",
    action_type: actionType.DELETE_SUPPLIER_DETAILS,
    description: "Remove Supplier Details",
  },
  get_supplier_details: {
    api_name: "/SCM/settings/search/suppliers",
    https_method: "GET",
    action_type: actionType.GET_SUPPLIER_DETAILS,
    description: "Get Supplier Details",
  },

  //delivery Market Details

  add_dellivery_market_details: {
    api_name: "/SCM/settings/add/delivery-market",
    https_method: "PUT",
    action_type: actionType.ADD_DELIVERY_MARKET_DETAILS,
    description: "Add DMarket Details",
  },
  delete_deliver_market_detials: {
    api_name: "/SCM/settings/remove/delivery-market",
    https_method: "PUT",
    action_type: actionType.DELETE_DELIVERY_MARKET_DETAILS,
    description: "Remove DMarket Details",
  },
  get_dellivery_market_details: {
    api_name: "/SCM/settings/search/delivery-markets",
    https_method: "GET",
    action_type: actionType.GET_DELIVERY_MARKET_DETAILS,
    description: "Get Delivery Market Details",
  },

  //Vehicle status Details
  get_vehicle_status: {
    api_name: "/SCM/settings/vstatus",
    https_method: "GET",
    action_type: actionType.GET_VEHICLE_STATUS,
    description: "",
  },
  add_vehicle_status: {
    api_name: "/SCM/settings/vstatus",
    https_method: "POST",
    action_type: actionType.ADD_VEHICLE_STATUS,
    description: "",
  },
  update_vehicle_status: {
    api_name: "/SCM/settings/vstatus",
    https_method: "PUT",
    action_type: actionType.UPDATE_VEHICLE_STATUS,
    description: "",
  },
  delete_vehicle_status: {
    api_name: "/SCM/settings/vstatus/delete",
    https_method: "PUT",
    action_type: actionType.DELETE_VEHICLE_STATUS,
    description: "",
  },

  //Vehicle Systems Details
  get_vehicle_systems: {
    api_name: "/SCM/settings/vsystems",
    https_method: "GET",
    action_type: actionType.GET_VEHICLE_SYSTEMS,
    description: "",
  },
  add_vehicle_systems: {
    api_name: "/SCM/settings/vsystems",
    https_method: "POST",
    action_type: actionType.ADD_VEHICLE_SYSTEMS,
    description: "",
  },
  update_vehicle_systems: {
    api_name: "/SCM/settings/vsystems",
    https_method: "PUT",
    action_type: actionType.UPDATE_VEHICLE_SYSTEMS,
    description: "",
  },
  delete_vehicle_systems: {
    api_name: "/SCM/settings/vsystems/delete",
    https_method: "PUT",
    action_type: actionType.DELETE_VEHICLE_SYSTEMS,
    description: "",
  },
  // Get vehicle component add requests
  get_vc_add_requests: {
    api_name: "/VLC/vehicle_components/add/requests",
    https_method: "GET",
    action_type: actionType.GET_VC_ADD_REQUESTS,
    description: "Get vehicle component add requests",
  },
  // Approve add vehicle component request
  approve_add_vc_request: {
    api_name: "/VLC/vehicle_components/add/request/approve",
    https_method: "PUT",
    action_type: "",
    description: "Approve add vehicle component request",
  },
  // Reject add vehicle component request
  reject_add_vc_request: {
    api_name: "/VLC/vehicle_components/add/request/reject",
    https_method: "PUT",
    action_type: "",
    description: "Reject add vehicle component request",
  },

  //Add Network Interfaces
  add_network_interfaces: {
    api_name: "/SCM/settings/add/network-interface",
    https_method: "POST",
    action_type: actionType.ADD_NETWORK_INTERFACES,
    description: "",
  },
  get_network_interfaces: {
    api_name: "/SCM/settings/view/network-interface",
    https_method: "GET",
    action_type: actionType.GET_NETWORK_INTERFACES,
    description: "",
  },
  get_ee_network_interfaces: {
    api_name: "/SCM/settings/view/network-interface",
    https_method: "GET",
    action_type: actionType.GET_EE_NETWORK_INTERFACES,
    description: "",
  },
  get_swm_network_interfaces: {
    api_name: "/SCM/settings/view/network-interface",
    https_method: "GET",
    action_type: actionType.GET_SWM_NETWORK_INTERFACES,
    description: "",
  },
  delete_network_interfaces: {
    api_name: "/SCM/settings/delete/network-interface",
    https_method: "PUT",
    action_type: actionType.DELETE_NETWORK_INTERFACES,
    description: "",
  },

  //Environment Details
  add_environment: {
    api_name: "/SCM/settings/add/environment",
    https_method: "POST",
    action_type: actionType.ADD_ENVIRONMENT,
    description: "Add Environment",
  },
  get_environment: {
    api_name: "/SCM/settings/view/environment",
    https_method: "GET",
    action_type: actionType.GET_ENVIRONMENT,
    description: "Get Environment",
  },
  delete_environment: {
    api_name: "/SCM/settings/delete/environment",
    https_method: "PUT",
    action_type: actionType.DELETE_ENVIRONMENT,
    description: "Delete Environment",
  },
};

export default adminSettingsAPI;
